import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'

const Spacer = ({ desktopHeight, tabletHeight, mobileHeight }) => {
    const useStyles = createUseStyles(theme => ({
        spacer: {
            height: desktopHeight,
            width: '100%',
            '@media (max-width: 769px)': {
                height: tabletHeight,
            },
            '@media (max-width: 600px)': {
                height: mobileHeight,
            },
        },
    }))
    const classes = useStyles()

    return <div className={classes.spacer}></div>
}

Spacer.propTypes = {
    desktopHeight: PropTypes.number,
    tabletHeight: PropTypes.number,
    mobileHeight: PropTypes.number,
}

export default Spacer
